import { Uint8ArrayWriter, ZipWriter } from '@zip.js/zip.js';
import { sourceToZipPath } from '../transformation/source_zip.js';
/**
 * This method will zip a file collection and return the zip as an ArrayBuffer
 * @param collection - The file collection to zip
 * @param finalPaths - toZip will fill this map with the final paths of the sources
 * @returns Zip as an Uint8Array
 */
export async function toZip(collection, finalPaths) {
    const zipWriter = new ZipWriter(new Uint8ArrayWriter());
    const pathUsed = new Set();
    await Promise.all(collection.sources.map(async (source) => {
        const path = sourceToZipPath(source, pathUsed);
        pathUsed.add(path);
        finalPaths?.set(source, path);
        await zipWriter.add(path, source.stream());
    }));
    return await zipWriter.close();
}
//# sourceMappingURL=to_zip.js.map